import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_BOOKINGS_DATA, FETCH_BOOKINGS_DETAILS_DATA } from "./actionTypes";
import {
  fetchBookingsSuccess,
  fetchBookingsFailure,
  fetchBookingsDetailsSuccess,
  fetchBookingsDetailsFailure
} from "./actions";

function* fetchBookingsDataSaga(data = null) {
  try {
    let url = process.env.REACT_APP_WEB_APP_URL + `/api/get-my-trips`;
    if (data.driverId) {
      url += `?driverId=${data.driverId}`;
    }
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, url,{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchBookingsSuccess(response.data));
  } catch (error) {
    yield put(fetchBookingsFailure(error.message));
  }
}

function* fetchBookingsDetailsDataSaga(action) {
  try {
    const id = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + `/api/web/bookings/${id}`,{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchBookingsDetailsSuccess(response.data));
  } catch (error) {
    yield put(fetchBookingsDetailsFailure(error.message));
  }
}

export default function* bookingsSaga() {
  yield takeEvery(FETCH_BOOKINGS_DATA, fetchBookingsDataSaga);
  yield takeEvery(FETCH_BOOKINGS_DETAILS_DATA, fetchBookingsDetailsDataSaga); 
}
